import { render } from "./Mantenimientos.vue?vue&type=template&id=40dbf341"
import script from "./Mantenimientos.vue?vue&type=script&lang=js"
export * from "./Mantenimientos.vue?vue&type=script&lang=js"

import "./Mantenimientos.vue?vue&type=style&index=0&id=40dbf341&scss=true&lang=css"

import exportComponent from "C:\\Users\\Josue\\Documents\\IMSS\\CDI\\SITE\\frontrdsyuc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__